import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import LoadingSpinner from '../LoadingSpinner/loadingSpinner';
import SidebarListButton from './SidebarListButton';
import SidebarListElement from './SidebarListElement';
import {
  lookupWorkFlowDepartment,
} from '../../actions/lookups';

const SidebarList = () => {
  const dispatch = useDispatch();
  const { site_map, hide_blank, work_flow, work_flows, departments, current_department, installation, database } = useSelector((state) => ({
    site_map: state.settings_nav.menus.site_map,
    hide_blank: state.settings_nav.menus.hide_blank,
    work_flow: state.settings_nav.menus.work_flow,
    work_flows: state.settings_departments.work_flows,
    departments: state.settings_departments.allowed_departments || [],
    current_department: state.settings_departments.department || {},
    installation: state.settings_dealerships.installation || {},
    database: state.settings_dealerships.installation.database,
  }));

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (work_flows.length > 0 && departments.length > 0 && loading) {
      setLoading(false);
    }
  }, [work_flows, departments, loading]);

  const buttons = [];
  buttons.push(
    <SidebarListButton
      key={'sitemap_button'}
      title={site_map ? 'Indent Sub Menus' : 'Align Sub Menus'}
      name="menu-sitemap"
      classtype="default"
      icon={'fas fa-sitemap'}
    />
  );
  buttons.push(
    <SidebarListButton
      key={'hideblank_button'}
      title={hide_blank ? 'Hide Empty Queues' : 'Show Empty Queues'}
      name="menu-hideblank"
      classtype="default"
      icon={hide_blank ? 'fas fa-eye-slash' : 'fas fa-eye'}
    />
  );
  buttons.push(
    <SidebarListButton
      key={'work_flow_button_a'}
      title="All Work Flows"
      name="menu-workflow"
      classtype="default"
      icon={'fas fa-chart-network'}
      text={'A'}
      workflow="all"
    />
  );

  work_flows.forEach((wf) => {
    if (wf.name !== 'all') {
      const text = wf.abbreviation || (wf.name || '').substring(0, 3);
      buttons.push(
        <SidebarListButton
          key={`work_flow_button_${wf.id}`}
          title={`${wf.name} Vehicle Work Flow`}
          name="menu-workflow"
          classtype="default"
          icon={'fas fa-chart-network'}
          text={text}
          workflow={wf.name}
        />
      );
    }
  });

  if (loading) {
    return <LoadingSpinner loading />;
  }

  return (
    <ul className="nav flex-column pl-1 nav-side" key={'SidebarList'}>
      <li className={'nav-item'}>
        <div style={{ display: 'block' }} className="btn-group bg-light-grey pad-top-p2 pad-bottom-p2">
          {buttons}
        </div>
      </li>
      {departments.map((department) => {
        const department_dealership = _.find(department.department_dealerships, { subdomain: installation.subdomain }) || {};
        const count = department_dealership.vehicle_count >= 0 ? department_dealership.vehicle_count : '...';
        const overdue_1 = department_dealership.overdue_1;
        const overdue_2 = department_dealership.overdue_2;

        if (department.name === 'sold') {
          return null;
        }

        const shouldRender = () => {
          if (site_map) {
            if (work_flow !== 'all') {
              if (hide_blank || database === 'stanley') {
                return count > 0 && dispatch(lookupWorkFlowDepartment(work_flow, department.id));
              }
              return dispatch(lookupWorkFlowDepartment(work_flow, department.id));
            }
            if (hide_blank || database === 'stanley') {
              return count > 0;
            }
            return true;
          }
          if (!department.subgroup) {
            if (work_flow !== 'all') {
              if (hide_blank || database === 'stanley') {
                return count > 0 && dispatch(lookupWorkFlowDepartment(work_flow, department.id));
              }
              return dispatch(lookupWorkFlowDepartment(work_flow, department.id));
            }
            if (hide_blank || database === 'stanley') {
              return count > 0;
            }
            return true;
          }
          return false;
        };

        if (shouldRender()) {
          return (
            <SidebarListElement
              count={count}
              overdue_1={overdue_1}
              overdue_2={overdue_2}
              key={`${department.id}_topmenu_${hide_blank ? 'hideblank' : 'nohide'}`}
              department={department}
              current_department_id={current_department.id}
            />
          );
        }
        return null;
      })}
    </ul>
  );
};

export default SidebarList;